import { render } from "./ChatPropsCmp.vue?vue&type=template&id=03025ffe&scoped=true"
import script from "./ChatPropsCmp.vue?vue&type=script&lang=js"
export * from "./ChatPropsCmp.vue?vue&type=script&lang=js"

import "./ChatPropsCmp.vue?vue&type=style&index=0&id=03025ffe&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03025ffe"]])

export default __exports__